import React from "react";

import InputError from "@/components/atoms/input/InputError";
import InputHelper from "@/components/atoms/input/InputHelper";
import InputLabel from "@/components/atoms/input/InputLabel";

export type FormControlProps = {
  label?: string;
  id: string;
  error?: string;
  helperText?: string;
  children: React.ReactNode;
  isOptional?: boolean;
  helperTextBelowLabel?: boolean;
};

const FormControl = ({
  label,
  id,
  error,
  helperText,
  isOptional,
  helperTextBelowLabel,
  children,
}: FormControlProps) => {
  if (helperTextBelowLabel) {
    return (
      <div className="grid gap-1.5 disabled-within:cursor-not-allowed disabled-within:opacity-40">
        {label && <InputLabel htmlFor={id} label={label} isOptional={isOptional} />}
        {helperText && <InputHelper text={helperText} />}
        {children}
        {error && <InputError error={error} />}
      </div>
    );
  }

  return (
    <div className="grid gap-1.5 disabled-within:cursor-not-allowed disabled-within:opacity-40">
      {label && <InputLabel htmlFor={id} label={label} isOptional={isOptional} />}
      {children}
      {error ? <InputError error={error} /> : helperText && <InputHelper text={helperText} />}
    </div>
  );
};

export default FormControl;
